export class PermissionUser{
    id:number;
    userId:number;
    permissionId:number
    
    createdBy:number;
    updatedBy:number;
    deletedBy:number;
}